/**
 * This page can be removed when users are added using aad groups
 */
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Table from "../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import _ from "lodash";
import { EditActions, editActions } from "../../actions/editActions";
import { isEditActiveSelector } from "../../reducers/editReducer";
import EditUser from "../Editing/EditUser";
import { Filter } from "../../components/Table/Migration/LegacyTypes";
import { mainActions } from "../../actions/mainActions";

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
};

type DispatchProps = {
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.UserSubmenu;
  toggleModal: () => void;
  setColumnFilters: (subMenuRoute: State.AnySubMenu | State.AnyChildItem, columnFilter: Filter[]) => void;
};

export type UsersTableProps = StateProps & DispatchProps & OwnProps;

type UsersTableState = {
  isModalOpen: boolean;
};

export class UsersTable extends React.Component<UsersTableProps, UsersTableState> {
  state = {
    isModalOpen: false
  };
  
  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive } = this.props;
    const { users } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let selectedColumns: State.Column[] = [];

    const rows: Api.User[] = [...users];
    selectedColumns = columns.Users;

    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            rows={rows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isUserSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}            
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditUser toggleModal={this.props.toggleModal} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  private isUserSelected = (parameter: Api.AnyParameter): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView)
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersTable);
